<template>
  <v-simple-table>
    <thead>
      <tr>
        <th>
          {{ $t('TrainingClient.Identity.name') }}
        </th>
        <!-- <th class="d-xs-none">
          department
        </th> -->
        <th class="width--date">
          {{ $t('eLeave.StartDate') }}
        </th>
        <th class="width--date">
          {{ $t('eLeave.EndDate') }}
        </th>
        <th>
          <v-btn
            color="primary"
            dark
            class="mb-2"
            small
            fab
            @click="newItem"
          >
            <v-icon>
              {{ mdiPlus }}
            </v-icon>
          </v-btn>
          <v-dialog
            v-model="dialog"
            max-width="600px"
          >
            <s-add-attention
              v-bind="addAttentionProps"
              @close="cancel"
            />
          </v-dialog>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(staff, index) in staffsAttentionMe"
        :key="staff.id"
      >
        <td>{{ $chPtObjData('chinFollowedByStaffName', staff) }}</td>
        <!-- <td class="d-xs-none">
          {{ staff.department }}
        </td> -->
        <template>
          <td>{{ momentWithHyphen(staff.startDate).format('YYYY-MM-DD') }}</td>
          <td>{{ momentWithHyphen(staff.endDate).format('YYYY-MM-DD') }}</td>
          <td>
            <!-- <v-btn
              icon
              @click="editItem(index)"
            >
              <v-icon>mdi-pencil-outline</v-icon>
            </v-btn> -->
            <v-btn
              v-if="!staff.isSecretary"
              icon
              @click="deleteItem(index)"
            >
              <v-icon>{{ mdiDeleteOutline }}</v-icon>
            </v-btn>
          </td>
        </template>
        <!-- <template v-else>
          <td
            colspan="3"
            class="grey--text text-center"
          >
            -- This cannot be remove --
          </td>
        </template> -->
      </tr>
    </tbody>

    <s-confirm-dialog
      v-model="isConfirmDeleteDialog"
      :message="$t('TaskList.AttentionManagement.CancelConfirmation')"
      @confirm="confirmDelete"
    />
  </v-simple-table>
</template>

<script>
import { mapState } from 'vuex'
import SConfirmDialog from '@/components/SConfirmDialog'
import SAddAttention from './SAddAttention'
import { workflowModule } from '../../../store/moduleName'
import workflowApi from '../../../api/workflow/workflow'
import { momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiPlus, mdiDeleteOutline } from '@mdi/js'

export default {
  components: {
    SAddAttention,
    SConfirmDialog
  },
  props: {
    euid: {
      type: String,
      default: null
    }
  },
  data: () => ({
    mdiDeleteOutline: mdiDeleteOutline,
    mdiPlus: mdiPlus,
    dialog: false,
    isConfirmDeleteDialog: false,
    deleteItemIndex: null,
    addAttentionProps: {
      mode: 'new', // new or edit
      index: -1, // index of the staffList
      staff: null, // follower
      masterEuid: null
    },
    // headers: [
    //   {
    //     text: 'name',
    //     value: 'name'
    //   },
    //   { text: 'department', value: 'department' },
    //   { text: 'startDate', value: 'startDate' },
    //   { text: 'endDate', value: 'endDate' },
    //   { text: null, value: 'action', sortable: false }
    // ],
    staffList: [],
    defaultProps: {
      mode: 'new',
      index: -1,
      staff: null,
      masterEuid: null
    }
  }),
  computed: {
    ...mapState(workflowModule, {
      items: state => state.items,
      staffsAttentionMe: state => state.staffsAttentionMe
      // myAttentionStaffs: state => state.myAttentionStaffs
    // BUSINESS_CODE: state => state[workflowModule].BUSINESS_CODE
    })
  },
  watch: {
    dialog: function (val) {
      if (val === false) { // clear data when dialog close
        this.addAttentionProps = this.defaultProps
      }
    }
  },
  created () {
    // this.$store.dispatch(workflowModule + '/getStaffsAttentionMe', this.euid)  // get staffs who attention me from AttentionTaskManage.vue
    // this.initialize()
  },
  methods: {
    newItem () {
      this.dialog = true
      this.addAttentionProps = this.defaultProps
      this.addAttentionProps.masterEuid = this.euid
    },

    editItem (index) {
      this.dialog = true
      this.addAttentionProps = {
        mode: 'edit',
        index: index,
        staff: this.staffsAttentionMe[index]
      }
    },

    deleteItem (index) {
      this.isConfirmDeleteDialog = true
      this.deleteItemIndex = index
    },

    confirmDelete () {
      let payload = {
        followedBy: this.staffsAttentionMe[this.deleteItemIndex].followedByEuid,
        euid: this.euid
      }
      workflowApi.deleteStaffFollower(cb => {
        if (cb.status === 201 || cb.status === 200) {
          this.$store.dispatch(workflowModule + '/getStaffsAttentionMe', this.euid)
        }
      }, payload)
      this.deleteItemIndex = null
    },

    cancel () {
      this.dialog = false
    },
    momentWithHyphen: momentWithHyphen
  }
}
</script>
